import xlsx from 'json-as-xlsx';
import moment from 'moment';
import insertIf from '../../../../utils/insertIf';
import transformWord from '../../../../utils/transformWord';

const LotesEntregasExport = (data, nombre_lote, mostrarCostalera = false, coopConfig) => {
  const agregaEstatusCostalera = xlsData => {
    if (mostrarCostalera) {
      const tipoDeCafeIndex = xlsData[0].columns.findIndex(col => col.value === 'tipo_cafe');
      if (tipoDeCafeIndex !== -1) {
        xlsData[0].columns.splice(tipoDeCafeIndex + 1, 0, {
          label: 'ESTATUS COSTALERA',
          value: row => (row.nombre_cat_costaleras_estatus ? row.nombre_cat_costaleras_estatus : '-'),
        });
      } else {
        xlsData[0].columns.push({
          label: 'ESTATUS COSTALERA',
          value: row => (row.nombre_cat_costaleras_estatus ? row.nombre_cat_costaleras_estatus : '-'),
        });
      }
    }
    return xlsData;
  };

  const agregaCalidad = xlsData => {
    if (+coopConfig?.config?.usa_calidad) {
      xlsData[0].columns.push(
        { label: 'ID MUESTRA', value: 'id_muestra' },
        { label: 'TIPO DE MUESTRA', value: 'nombre_tipo_muestra' },
        { label: 'RENDIMIENTO BRUTO (%)', value: 'rendimiento_bruto' },
        { label: 'RENDIMIENTO EXPORTABLE (%)', value: 'rendimiento_exportable_por' },
        { label: 'RENDIMIENTO REAL (%)', value: 'rendimiento_real' },
        { label: 'PUNTAJE EN TAZA', value: 'puntaje_manual' }
      );
    }
    return xlsData;
  };

  let xlsData = [
    {
      sheet: 'Entregas',
      columns: [
        { label: 'FECHA ENTREGA', value: 'fecha_acopio' },
        { label: 'FOLIO ENTREGA', value: 'folio_acopio' },
        ...insertIf(!coopConfig.hasAcopioUnitsExtra(), {
          label: `PESO ASIGNADO (${coopConfig.acopioUnits()?.abreviacion})`,
          value: 'peso_asignado_lote',
        }),
        ...insertIf(coopConfig.hasAcopioUnitsExtra(), {
          label: `PESO ASIGNADO (${coopConfig.acopioUnitsExtra()?.abreviacion})`,
          value: 'peso_asignado_lote_extra',
        }),
        { label: 'CLAVE', value: 'productor_clave_tx' },
        { label: 'CÓDIGO', value: 'productor_codigo_tx' },
        { label: 'NOMBRE PRODUCTOR', value: 'productor_nombre' },
        { label: 'LOCALIDAD', value: 'localidad' },
        { label: 'REGIÓN', value: 'region' },
        { label: 'CENTRO DE ACOPIO', value: 'centro_acopio' },
        { label: 'Nº RECIPIENTES', value: 'no_bultos' },
        { label: 'PESO BRUTO (KGS)', value: 'peso_bruto' },
        { label: 'PESO TARA (KGS)', value: 'peso_tara' },
        { label: 'PESO DESC. (KGS)', value: 'peso_descuento' },
        { label: 'PESO NETO (KGS)', value: 'peso_neto' },
        { label: 'TIPO DE ' + transformWord(coopConfig?.config?.cooperativa?.producto?.nombre || 'café', ['uppercase']), value: 'tipo_cafe' },
        { label: 'PROCESO', value: 'proceso' },
        { label: 'CATEGORÍA', value: 'cuenta_categoria' },
        { label: 'RENDIMIENTO', value: 'rendimiento' },
        { label: 'HUMEDAD', value: 'humedad' },
        { label: 'DEFECTO', value: 'mancha' },
        { label: 'AROMA', value: 'aroma' },
        { label: 'ESTADO', value: 'estatus' },
        { label: 'PRECIO A PRODUCTOR ($/KG)', value: 'precio_por_kg' },
        { label: 'IMPORTE TOTAL ($)', value: 'importe_total' },
        { label: 'DESCUENTOS DEUDAS', value: 'total_anticipos_recuperados' },
        { label: 'PAGADO A PRODUCTOR ($)', value: 'pagado_a_productor' },
        { label: 'SALDO DE LA ENTREGA ($)', value: 'total_saldo' },
        { label: 'MÉTODO DE PAGO', value: 'metodo_pago' },
        { label: 'OBSERVACIONES', value: 'observaciones' },
      ],
      content: data,
    },
  ];

  let settings = {
    fileName: `Entregas_${nombre_lote}_${moment().format('YYYYMMDD_HHmmss')}`,
  };
  xlsx(agregaCalidad(agregaEstatusCostalera(xlsData)), settings);
};

export default LotesEntregasExport;
